import { SET_USER_DISCOUNT } from "../actions/types";

export default function (state = null, action) {
  switch (action.type) {
    case SET_USER_DISCOUNT:
      return action.payload;
    default:
      return state;
  }
}
